import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';

import { Segment, Grid, Popup, Icon, Image } from 'semantic-ui-react';
import { Checkbox } from 'material-ui';

import { TagItem } from 'components';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';


import styles from './TargetItem.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class TargetItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      tagDataByTagNo,
      target,
      selectTarget,
      onDeleteTarget,
      handleCheckTarget,
      handleSelectTarget
    } = this.props;
    const {
      targetNo,
      targetId,
      targetName,
      targetEmail,
      targetPhone,
      targetDivision,
      targetPosition,
      employeeNumber,
      targetDetail,
      tagList,
      examInfo,
      regEpoch
    } = target.toJS();

    const tagComponent =
      !!target.get('tagList') &&
      target
        .get('tagList')
        .sort()
        .map(
          // 컴포넌트로 매핑
          // 태그 삭제시 강제로 삭제 처리
          tagNo => {
            if (
              tagNo &&
              typeof tagDataByTagNo.get(String(tagNo)) !== 'undefined'
            ) {
              return (
                <TagItem
                  key={tagNo}
                  tagItem={tagDataByTagNo.get(String(tagNo))}
                  className={cx('targetItem-tagItem')}
                  size="small"
                />
              );
            }
          }
        );

    // 0: 결과 없음 1: 양호 2: 열람 3: 파일 다운 4: 피싱 접속 5: PC 감염 6: 정보 유출
    let examStatus = 0;
    if (!!examInfo) {
      examStatus = 1;
      // 메일 열람
      if (!!examInfo.read) {
        examStatus = 2;
        // 파일 다운
        if (!!examInfo.download) {
          if (examInfo.examType === 4) {
            examStatus = 4;
          } else {
            examStatus = 3;
          }
        }
        // 감염
        if (!!examInfo.infection) {
          if (examInfo.examType === 4) {
            examStatus = 6;
          } else {
            examStatus = 5;
          }

          // 치료
          if (!!examInfo.cure) {
            examStatus = 7;
          }
        }
      }
    }

    return (
      <Segment
        vertical
        className={cx('targetItem-wrapper', {
          selected:
            selectTarget.get('isType') === 'select' &&
            selectTarget.get('targetNoArray').indexOf(targetNo) !== -1
        })}
        onClick={e => {
          e.stopPropagation();

          if (e.target && e.target.className &&
            (e.target.type === 'checkbox' || e.target.className.indexOf('cell-checkBox') > -1)) {
            handleCheckTarget(targetNo, e.shiftKey);
          } else {
            handleSelectTarget(targetNo);
          }
        }}>
        <Grid columns="equal" stackable>
          <Grid.Row textAlign="center">
            <Grid.Column className={cx('cell-checkBox')}>
              <Checkbox
                checkedIcon={<Image src="/img/exam/list_check_on.png" />}
                className={cx('targetItem-checkBox')}
                checked={
                  selectTarget.get('isType') === 'check' &&
                    // 단일 체크
                    (selectTarget.get('targetNoArray').indexOf(targetNo) !== -1 ||
                      // 전체선택
                      selectTarget.get('isAllCheckTarget') === 2)
                    ? true
                    : false
                }
              />
            </Grid.Column>
            <Grid.Column className={cx('cell-targetName')} textAlign="left">
              {/* 대상자 정보 */}
              <Popup
                trigger={
                  <div className={cx('targetInfo-area', 'ellipsis')}>
                    <div
                      className={cx(
                        { 'brand-green': examStatus === 1 },
                        { 'color-orange': examStatus === 2 },
                        { 'color-down': examStatus === 3 },
                        { 'color-down': examStatus === 4 },
                        { 'color-red': examStatus === 5 },
                        { 'color-red': examStatus === 6 },
                        { 'color-cure': examStatus === 7 }
                      )}>
                      <Icon name="user" />
                    </div>
                    <span className={cx('targetName')}>{targetName}</span>
                    <span className={cx('targetEmail ellipsis')}>
                      ({targetEmail})
                    </span>
                  </div>
                }
                content={
                  <div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(
                          formatMessage({
                            id: 'TargetItem_8',
                            defaultMessage: '최근 훈련 결과'
                          })
                        )}
                      </div>
                      <div
                        className={cx(
                          'bold',
                          { 'brand-green': examStatus === 1 },
                          { 'color-orange': examStatus === 2 },
                          { 'color-down': examStatus === 3 },
                          { 'color-down': examStatus === 4 },
                          { 'color-red': examStatus === 5 },
                          { 'color-red': examStatus === 6 },
                          { 'color-cure': examStatus === 7 }
                        )}>
                        {examStatus === 0 &&
                          defineMessages(
                            formatMessage({
                              id: 'TargetItem_9',
                              defaultMessage: '없음'
                            })
                          )}
                        {examStatus === 1 &&
                          defineMessages(
                            formatMessage({
                              id: 'TargetItem_10',
                              defaultMessage: '양호'
                            })
                          )}
                        {examStatus === 2 &&
                          defineMessages(
                            formatMessage({
                              id: 'TargetItem_11',
                              defaultMessage: '메일 열람'
                            })
                          )}
                        {examStatus === 3 &&
                          defineMessages(
                            formatMessage({
                              id: 'CtExamChart_5',
                              defaultMessage: '파일 다운'
                            })
                          )}
                        {examStatus === 4 &&
                          defineMessages(
                            formatMessage({
                              id: 'TargetItem_13',
                              defaultMessage: '피싱 접속'
                            })
                          )}
                        {examStatus === 5 &&
                          defineMessages(
                            formatMessage({
                              id: 'TargetItem_12',
                              defaultMessage: 'PC 감염'
                            })
                          )}
                        {examStatus === 6 &&
                          defineMessages(
                            formatMessage({
                              id: 'TargetItem_14',
                              defaultMessage: '정보 유출'
                            })
                          )}
                        {examStatus === 7 &&
                          defineMessages(
                            formatMessage({
                              id: 'TargetDetail_34',
                              defaultMessage: '치료'
                            })
                          )}
                      </div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(
                          formatMessage({
                            id: 'TargetItem_1',
                            defaultMessage: '대상자 번호'
                          })
                        )}
                      </div>
                      <div className={cx('bold')}>{targetNo}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(
                          formatMessage({
                            id: 'TargetDetail_21',
                            defaultMessage: '이름'
                          })
                        )}
                      </div>
                      <div className={cx('bold')}>{targetName}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(
                          formatMessage({
                            id: 'TargetDetail_22',
                            defaultMessage: '이메일'
                          })
                        )}
                      </div>
                      <div className={cx('bold')}>{targetEmail}</div>
                    </div>
                    {!!targetPhone && (
                      <div className={cx('targetInfo-area')}>
                        <div className={cx('targetInfo-title')}>
                          {defineMessages(
                            formatMessage({
                              id: 'TargetItem_2',
                              defaultMessage: '연락처'
                            })
                          )}
                        </div>
                        <div className={cx('bold')}>{targetPhone}</div>
                      </div>
                    )}
                  </div>
                }
                size="mini"
              />
            </Grid.Column>
            <Grid.Column className={cx('cell-company', { left: commonVar.isSaas === 0 })}>
              <Popup
                trigger={
                  <div className={cx('target-division', 'ellipsis')}>
                    {targetDivision ? targetDivision : '-'}
                  </div>
                }
                content={
                  <div>
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'TargetItem_3',
                          defaultMessage: '소속'
                        })
                      ) + ' '}
                    </span>
                    <span className={cx('bold')}>
                      {targetDivision ? targetDivision : '-'}
                    </span>
                  </div>
                }
                size="mini"
              />
              <Popup
                trigger={
                  <div className={cx('target-position', 'ellipsis')}>
                    {targetPosition ? targetPosition : '-'}
                  </div>
                }
                content={
                  <div>
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'TargetItem_4',
                          defaultMessage: '직급'
                        })
                      ) + ' '}
                    </span>
                    <span className={cx('bold')}>
                      {targetPosition ? targetPosition : '-'}
                    </span>
                  </div>
                }
                size="mini"
              />
              {!!employeeNumber && (
                <Popup
                  trigger={
                    <div className={cx('target-number', 'ellipsis')}>
                      {employeeNumber ? employeeNumber : '-'}
                    </div>
                  }
                  content={
                    <div>
                      <span>
                        {defineMessages(
                          formatMessage({
                            id: 'TargetItem_15',
                            defaultMessage: '사번'
                          })
                        ) + ' '}
                      </span>
                      <span className={cx('bold')}>
                        {employeeNumber ? employeeNumber : '-'}
                      </span>
                    </div>
                  }
                  size="mini"
                />
              )}
            </Grid.Column>
            <Grid.Column className={cx('cell-tag')} textAlign="right">
              {!!target.get('tagList') ? (
                <Popup
                  className="max-250"
                  trigger={
                    <div className={cx('cell-tag-inner', 'ellipsis')}>
                      <div>{tagComponent}</div>
                    </div>
                  }
                  content={
                    !!target.get('tagList') && (
                      <div className={cx('target-tagPopup')}>
                        <div className={cx('bold', 'font-size-13')}>
                          <span>
                            {defineMessages(
                              formatMessage({
                                id: 'TargetItem_5',
                                defaultMessage: '태그'
                              })
                            )}
                          </span>
                          <span
                            className={cx(
                              'dark-grey font-size-12 vertical-top'
                            )}>
                            {'(' +
                              defineMessages(
                                formatMessage({
                                  id: 'TargetItem_6',
                                  defaultMessage: '총'
                                })
                              ) +
                              ' ' +
                              target.get('tagList').size +
                              defineMessages(
                                formatMessage({
                                  id: 'TargetItem_7',
                                  defaultMessage: '개'
                                })
                              ) +
                              ')'}
                          </span>
                        </div>
                        <div className={cx('mt-5')}>{tagComponent}</div>
                      </div>
                    )
                  }
                  size="mini"
                  position="top right"
                />
              ) : (
                  <div className={cx('no-tagList')}>
                    {defineMessages(
                      formatMessage({
                        id: 'TargetDetail_9',
                        defaultMessage: '태그를 등록하세요'
                      })
                    )}
                  </div>
                )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

TargetItem.propTypes = {
  target: ImmutablePropTypes.mapContains({
    targetNo: PropTypes.number,
    targetId: PropTypes.string,
    targetName: PropTypes.string,
    targetEmail: PropTypes.string,
    targetPhone: PropTypes.string,
    targetDivision: PropTypes.string,
    targetPosition: PropTypes.string,
    employeeNumber: PropTypes.string,
    targetDetail: PropTypes.string,
    modifyEpoch: PropTypes.number,
    regEpoch: PropTypes.number
  }),
  onDeleteTarget: PropTypes.func
};

export default injectIntl(TargetItem);



// WEBPACK FOOTER //
// ./src/script/components/target/TargetItem.js